export default {
    "Pricing.index.525610-0": "Pricing",
    "Pricing.index.525610-1": "The future updates of AppKit Landing are completely free for existing customers",
    "Pricing.index.525610-2": "FREE",
    "Pricing.index.525610-3": "(Source must be indicated)",
    "Pricing.index.525610-4": "Single installation",
    "Pricing.index.525610-5": "Multiple installations",
    "Pricing.index.525610-6": "Links can be used without indicating the source",
    "Pricing.index.525610-7": "Single Application",
    "Pricing.index.525610-8": "(Commercial License)",
    "Pricing.index.525610-9": "Multi Application",
    "Pricing.index.525610-10": "License Details",
}